// components

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";

// css
import styles from './userMonitor_mobile.module.css';
import './userMonitor_mobile.css'

// services

function UserMonitorGridMobile({dataSource, search}) {

  // 시간 포맷
  const hourFormat = (e) => {
    if(e.dataItem.hour < 10) {
      return <td>0{e.dataItem.hour}시</td>
    } else {
      return <td>{e.dataItem.hour}시</td>
    }
  }

  const dateFormat = (e) => {
    
    return <td>{kendo.toString(new Date(e.dataItem.date), "yyyy년 MM월 dd일")}</td>;
  }

  // 시간 그리드
  const timeGridColumn = () => {
    if(search.dateType === "HH") {
      return <GridColumn title="시간" field="hour" cell={hourFormat}/> 
    } else if(search.dateType === "DD") {
      return <GridColumn title="날짜" field="date" cell={dateFormat}/> 
    } else if(search.dateType === "MM") {
      return <GridColumn title="날짜" field="date" cell={dateFormat}/> 
    }
  }

  // 데이터 그리드
  const dataGridColumn = () => {
    if(search.dataType === "movement") {
      return <GridColumn title="움직임" field="movement" />
    } else if(search.dataType === "temperature") {
      return <GridColumn title="온도 (°C)" field="temperature" />
    } else if(search.dataType === "humidity") {
      return <GridColumn title="습도 (%)" field="humidity" />
    } else if(search.dataType === "co2") {
      return <GridColumn title="co2 (ppm)" field="co2" />
    } else if(search.dataType === "light") {
      return <GridColumn title="조도 (Lx)" field="light" />
    } else if(search.dataType === "velocityTotal") {
      return <GridColumn title="활동량" field="velocityTotal" />
    } else {
      return;
    }
  }

  useEffect(() => {

  },[])

  return (
    <>
      <LocalizationProvider language="ko-KR">
        <IntlProvider locale="ko">
          <Grid
            data={dataSource.datalist}
            className="userMonitorGrid"
            >
            {timeGridColumn()}
            {dataGridColumn()}
          </Grid>
        </IntlProvider>
      </LocalizationProvider>
    </>
  );
}

export default UserMonitorGridMobile;
